<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 36 36"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M21.35 15.906c.477-.107.916.286.82.756-.621 2.995-3.298 5.25-6.525 5.236-3.576-.016-6.616-3.025-6.619-6.551-.001-3.218 2.353-5.89 5.458-6.443a.657.657 0 0 1 .747.823 4.876 4.876 0 0 0 .124 2.86 5.157 5.157 0 0 0 3.664 3.3c.816.192 1.602.18 2.332.019zm-16.584-.51c0 5.899 4.853 10.682 10.838 10.682 5.985 0 10.84-4.783 10.84-10.683 0-5.9-4.855-10.683-10.84-10.683-5.985 0-10.838 4.784-10.838 10.683zm22.452 8.724c-1.027 1.203-2.128 2.263-3.33 3.13-2.76 1.878-6.208 2.846-9.897 2.455-6.814-.722-12.318-6.253-12.93-12.983C.21 7.363 8.456-.35 18.071 1.2c6.069.98 10.955 5.81 11.94 11.794.69 4.198-.47 8.126-2.794 11.127zm2.67 10.101l-3.028-2.834a2.806 2.806 0 0 1-.106-4.008 2.906 2.906 0 0 1 4.067-.104l3.027 2.834a2.808 2.808 0 0 1 .106 4.008 2.906 2.906 0 0 1-4.066.104z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
